import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { PAYWALL_TIMER_MINUTES, SELECT_PLAN_SECTION_ID } from '@/constants';
import { LimitedTimerHoc } from '@/pages/Paywall/components/LimitedTimerHoc';
import { scrollToById } from '@/utils/scrollToById';

import { PaywallFixedTimerStyles } from './FixedTimer.styles';

export const PaywallFixedTimer: React.FC = () => {
  const handleGoPremium = () => {
    scrollToById(SELECT_PLAN_SECTION_ID);
  };

  return (
    <PaywallFixedTimerStyles>
      <div className="local-wrapper">
        <div className="local-numbers">
          <LimitedTimerHoc timeToExpire={PAYWALL_TIMER_MINUTES * 1000 * 60}>
            {({ minutes, seconds }) => {
              return (
                <>
                  <div>
                    <div className="local-numbers-number">{minutes}</div>
                    <UiTypography
                      variant="body-small"
                      className="local-numbers-label"
                    >
                      min
                    </UiTypography>
                  </div>
                  <div className="local-numbers-semicolon">:</div>
                  <div>
                    <div className="local-numbers-number">{seconds}</div>
                    <UiTypography
                      variant="body-small"
                      className="local-numbers-label"
                    >
                      sec
                    </UiTypography>
                  </div>
                </>
              );
            }}
          </LimitedTimerHoc>
        </div>
        <button
          onClick={handleGoPremium}
          type="button"
          className="local-button"
        >
          GO PREMIUM
        </button>
      </div>
    </PaywallFixedTimerStyles>
  );
};
